<div class="kh-panel" *ngIf="open">
    <div class="kh-header">
        <button *ngIf="seleccionado" mat-icon-button (click)="volver()" aria-label="Volver">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="kh-title">{{ seleccionado ? seleccionado.title : 'Ayuda' }}</span>
        <button mat-icon-button (click)="cerrar()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="kh-scroll">
        <ng-container *ngIf="!seleccionado; else detalle">
            <div *ngIf="groups.length === 0" class="kh-empty">
                No hay artículos de ayuda para esta pantalla.
            </div>
            <div class="kh-group" *ngFor="let g of groups">
                <div class="kh-group-title">{{ g.categoryName }}</div>
                <button class="kh-item" *ngFor="let a of g.articles" (click)="abrirArticulo(a)">
                    <div class="kh-item-title">{{ a.title }}</div>
                    <div class="kh-item-summary" *ngIf="a.summary">{{ a.summary }}</div>
                    <mat-chip-list *ngIf="a.tags?.length" [selectable]="false">
                        <mat-chip *ngFor="let t of a.tags" [style.background-color]="t.color || '#e0e0e0'" [disableRipple]="true">
                            {{ t.label }}
                        </mat-chip>
                    </mat-chip-list>
                </button>
            </div>
        </ng-container>
        <ng-template #detalle>
            <div class="kh-detail" *ngIf="seleccionado">
                <markdown [data]="seleccionado.body || ''"></markdown>
            </div>
        </ng-template>
    </div>
</div>
